module.exports = __webpack_public_path__ + "Wireframes8.png?225cb5c81c6246ad344c496ed004a1bf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Wireframes8.png
// module id = 122
// module chunks = 0